import React from "react";

import { TCollabThread, TiptapCollabProvider } from "@tiptap-pro/provider";

import { Box, IconButton } from "@mui/material";

import { Close } from "@mui/icons-material";

import CommentUI from "containers/Tiptap/components/tiptap-ui/comment-ui/comment-ui";

import { colors } from "theme/colors";

import { Sidebar as SidebarStyles } from "./styles";
import { SidebarEnum } from "./types";

import "./extension-styles.css";
import "./simple-editor.scss";

interface SidebarProps {
  provider: TiptapCollabProvider;
  threads: TCollabThread[];
  setSelectedThread: (thread: string | null) => void;
  activeSidebar: false | SidebarEnum.Versioning | SidebarEnum.Comments;
  setActiveSidebar: (sidebar: false | SidebarEnum.Versioning | SidebarEnum.Comments) => void;
}

export function Sidebar({
  provider,
  threads,
  activeSidebar,
  setActiveSidebar,
  setSelectedThread,
}: SidebarProps): React.ReactNode {
  const handleCloseComments = React.useCallback(() => {
    setActiveSidebar(false);
    setSelectedThread(null);
  }, []);

  const [isScrolledDown, setIsScrolledDown] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = (): void => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolledDown(scrollTop > 200);
    };

    if (activeSidebar === SidebarEnum.Comments) {
      window.addEventListener("scroll", handleScroll, { passive: true });
      handleScroll();

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
    return undefined;
  }, [activeSidebar]);

  if (activeSidebar !== SidebarEnum.Comments) {
    return null;
  }

  return (
    <SidebarStyles $isScrolledDown={isScrolledDown}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "10px 16px",
        }}
      >
        <Box sx={{ color: "inherit", fontSize: "18px", fontWeight: 400, letterSpacing: "0.15px" }}>
          Comments
        </Box>

        <IconButton
          size="small"
          sx={{ border: `1px solid ${colors.grey[300]}`, borderRadius: "50%" }}
          onClick={handleCloseComments}
        >
          <Close />
        </IconButton>
      </Box>
      <CommentUI isOpen provider={provider} threads={threads} />
    </SidebarStyles>
  );
}
